module.exports = __webpack_public_path__ + "static/media/1POLICY31.70cc8857.jpg";